import React, { Component } from 'react';
import { Spin, Button, Icon, message } from 'antd';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';
import Update from './Update';

class TerminationApply extends Component {
    state = {
        data: null,
        showTips: true,
        loading: false,
    }

    componentDidMount() {
        const { invId: investigationId } = sessionStorage;
        this.queryInvestigationStageByInvId(investigationId, () => this.loadData());
    }

    loadData = () => {
        const { invId: investigationId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.proContract.getInvTerminationApplyInfo,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data, data: { jdeApplyId, invTerminationApplyId } } = res;
                this.setState({
                    data,
                    showTips: !jdeApplyId && !invTerminationApplyId,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    loading: false,
                    invStageList: data,
                }, () => {
                    callback();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    changeShowTips = showTips => {
        this.setState({ showTips });
    }

    render() {
        const { curRole } = sessionStorage;
        const { data, showTips, loading } = this.state;
        return (
            <div className="content">
                <SideNav selectKey="terminationApply" />
                <div className="main">
                    <h3 style={{ fontWeight: 'bold' }}>项目终止申请</h3>
                    <Spin spinning={loading}>
                        {
                            (curRole == 'PM') &&
                            (
                                showTips ?
                                    <div style={{ marginTop: 100, marginBottom: 100, textAlign: 'center' }}>
                                        <div style={{ width: 632, margin: '20px auto' }}>
                                            <Icon type="info-circle" style={{ marginRight: 4, fontSize: '14px', color: '#5750c9', }} />
                                            项目若需要中途终止，需由PM提交项目终止申请。提交申请后，由BD提交JDE建号申请“终止合同”，申请项目终止。【项目终止后，将不能填写除项目合同请款外的任何项目数据】
                                        </div>
                                        <Button type="primary" onClick={() => this.canEditByInvStatus(() => this.changeShowTips(false))}>提交项目终止申请</Button>
                                    </div>
                                :
                                    <Update
                                        data={data}
                                        loadData={this.loadData}
                                        changeShowTips={this.changeShowTips}
                                    />
                            )
                        }
                        {
                            (curRole !== 'PM') &&
                            (
                                showTips ?
                                    <div style={{ marginTop: 100, marginBottom: 100, textAlign: 'center' }}>
                                        <div className="terminationApply_bg" />
                                        项目尚未申请终止
                                    </div>
                                :
                                    <Update
                                        data={data}
                                        loadData={this.loadData}
                                    />
                            )
                        }
                    </Spin>
                </div>
            </div>
        )
    }
}

export default TerminationApply;


// WEBPACK FOOTER //
// ./src/components/projectContract/terminationApply/index.js